function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, isAddingFilter) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['block-prefix'] = function(idx) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((idx === 0) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("where");;
          return __jade_nodes
        }).call(this)) : (idx === 1) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-select", {
            "attrs": {
              'menu-width': '60',
              'options': JSON.stringify($helpers.BOOLEAN_OPERATORS),
              'selected-option': $attr(`selected-filters-operator`),
              'theme': 'builder',
            },
            "on": {
              change: $helpers.onFiltersOperatorSelected
            },
          }));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat($attr(`selected-filters-operator`));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this);
    };
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'is-adding-filter': isAddingFilter
        }, {
          'mp-query-event-selector': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-event-selector-row': true
          },
        }, (function() {
          var __jade_nodes = []; /*  slotted content to provide a sentence structure for the selector */
          __jade_nodes = __jade_nodes.concat(h("slot", {
            "attrs": {
              name: `event-prefix`
            },
          }));
          __jade_nodes = __jade_nodes.concat(h("mp-query-block", {
            "attrs": Object.assign($helpers.getQueryBlockConfig(), {
              'all-data-groups': $attr(`data-groups-enabled`),
              'data-group-id': $attr(`data-group-id`),
              'enable-behavioral-properties': $attr(`enable-behavioral-properties`),
              'exclude-close-selectors': JSON.stringify($attr(`exclude-close-selectors`)),
              'open': $attr(`open`),
              'disabled': $attr(`disable-event-selection`),
              'project-id': $attr(`project-id`),
              'user-id': $attr(`user-id`),
              'selected': JSON.stringify($attr(`selected-event`) || null),
              'hide-edit-controls': $attr(`hide-edit-controls`),
              'show-special-date-property': $attr('show-special-date-property'),
              'show-special-date-property-unit': $attr('show-special-date-property-unit'),
              'theme': `builder`,
              'workspace-id': $attr(`workspace-id`),
            }),
            "dataset": {
              key: `event`
            },
            "on": {
              deletedCustomEvent: $helpers.propagateEvent,
              savedCustomEvent: $helpers.propagateEvent,
              open: $helpers.propagateEvent,
              close: $helpers.propagateEvent,
              select: $helpers.onEventSelected,
            },
          })); /*  slotted content to be rendered as additional controls for the selector */
          __jade_nodes = __jade_nodes.concat(h("slot", {
            "attrs": {
              name: `event-suffix`
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-event-selector-row': true,
            'for-event-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("slot", {
            "attrs": {
              name: `event-row`
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(($attr(`selected-filters`).length || $attr(`show-placeholder`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-query-event-selector-row': true,
              'for-filters': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-query-multi-block", {
              "attrs": {
                'type': `filter`,
                'all-data-groups': $attr(`data-groups-enabled`),
                'data-group-id': $attr(`data-group-id`),
                'adding-disabled': !$attr(`show-placeholder`),
                'button-icon': ``,
                'button-input-only': false,
                'button-is-removable': true,
                'button-selector-type': `text`,
                'button-selector-theme': `builder`,
                'button-open': $attr(`show-placeholder`),
                'enable-behavioral-properties': $attr(`enable-behavioral-properties`),
                'event-names': JSON.stringify($helpers.hasSelectedEvent() ? [$attr(`selected-event`).value] : []),
                'exclude-close-selectors': JSON.stringify($attr(`exclude-close-selectors`)),
                'include-custom-properties': $attr(`include-custom-properties`),
                'layout': `column`,
                'project-has-events': $attr(`project-has-events`),
                'project-has-people': $attr(`project-has-people`),
                'project-has-cohorts': $helpers.getQueryBlockConfig()[`project-has-cohorts`],
                'project-id': $attr(`project-id`),
                'user-id': $attr(`user-id`),
                'selected': JSON.stringify($attr(`selected-filters`)),
                'hide-edit-controls': $attr(`hide-edit-controls`),
                'show-special-date-property': $attr('show-special-date-property'),
                'show-special-date-property-unit': $attr('show-special-date-property-unit'),
                'theme': `builder`,
                'workspace-id': $attr(`workspace-id`),
              },
              "dataset": {
                key: `filters`
              },
              "on": {
                update: $helpers.onFilterSelected,
                close: $helpers.propagateEvent,
              },
              "props": {
                prefixRenderer: $mixins[`block-prefix`]
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "isAddingFilter" in locals ? locals.isAddingFilter : typeof isAddingFilter !== "undefined" ? isAddingFilter : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;